import React from "react";

interface AccordionPanelProps {
  id: number;
  title: string;
  content: string;
  isOpen: boolean;
  onClick: (id: number) => void; // Function to handle click
}

const AccordionPanel: React.FC<AccordionPanelProps> = ({ id, title, content, isOpen, onClick }) => {
  return (
    <div className="panel panel-default">
      <div className="panel-heading">
        <h4 className={`panel-title ${isOpen ? "active" : ""}`}>
          <a
            onClick={() => onClick(id)} // Trigger onClick
            className={isOpen ? "" : "collapsed"}
          >
            <span>
              <i className={`fa ${isOpen ? "fa-minus" : "fa-plus"}`}></i>
            </span>
            {title}
          </a>
        </h4>
      </div>

      <div id={`collapse${id}`} className={`panel-collapse collapse ${isOpen ? "in" : ""}`}>
        <div className="panel-body" dangerouslySetInnerHTML={{ __html: content }} />
      </div>
    </div>
  );
};

export default AccordionPanel;
